import { GetterTree } from 'vuex'
import { RootState, Pawn, Player, Teams, Breaths } from './types'

const getters: GetterTree<RootState, RootState> = {
  gameIsWonByTeam(state: RootState) {
    return state.gameIsWonByTeam
  },
  boardX(state: RootState) {
    return state.boardX
  },
  boardY(state: RootState) {
    return state.boardY
  },
  boardZoomFactor(state: RootState) {
    return state.boardZoomFactor
  },
  tableID(state: RootState): number | null {
    return state.tableID
  },
  turnID(state: RootState): number {
    return state.turnID
  },
  pawns(state: RootState): Pawn[] {
    return state.pawns
  },
  teams(state: RootState): Teams {
    return state.teams
  },
  players(state: RootState): Player[] {
    return state.players
  },
  activeSeatID(state: RootState): number {
    return state.turnID % 4
  },
  yourTurn(state: RootState): boolean {
    return state.yourTurn
  },
  activeTeamID(state: RootState): string {
    return state.turnID % 4 < 2 ? 'teamA' : 'teamB'
  },
  breaths(state: RootState): Breaths {
    return state.breaths
  },
}

export default getters
